import { EBreadcrumbKey } from '~/shared/types';
export const getBreadcrumbs = (defaultBreadcrumbs, mediasSearchService) => {
    const defaultItems = mediasSearchService.subCategories.length > 0
        ? [
            ...defaultBreadcrumbs,
            {
                key: EBreadcrumbKey.media,
            },
        ]
        : defaultBreadcrumbs;
    return mediasSearchService.subCategories.length > 1
        ? mediasSearchService.subCategories.reduce((breadcrumbs, subCategory, currentIndex) => {
            if (currentIndex === mediasSearchService.subCategories.length - 1) {
                return breadcrumbs;
            }
            return [
                ...breadcrumbs,
                {
                    key: EBreadcrumbKey.subCategory,
                    breadcrumbId: subCategory.breadCrumbId,
                    breadcrumbName: subCategory.breadCrumbName,
                },
            ];
        }, defaultItems)
        : defaultItems;
};
